
import './App.scss';
import React, { useReducer, useEffect, useState, useCallback } from 'react';
import { StateContext } from './Util/StateContext/StateContext';
import { useQueries } from 'react-query'
import { reducer, initialState, initializer } from './Util/Reducer/Reducer';
import { fetchFilterOptions, fetchPagedProducts, } from './Util/FetchAPI/FetchAPI';
// import { usePrevious } from './Util/usePrevious/usePrevious';


/**Components */
import Table from './Components/Table/Table';
import RequestCart from './Components/RequestCart/RequestCart';
import Loader from './Components/Loader/Loader';
import Pagination from './Components/Pagination/Pagination'
import Filtering from './Components/Filtering/Filtering';


function App(props) {
  const [state, dispatch] = useReducer(reducer, initialState, initializer);
  const [showFilters, setShowFilters] = useState(false);
  const [dataRetrived, setDataRetrived] = useState(false);

  const prefetchQueries = useCallback(
    (paged) => {
      for (let i = paged; i < paged + 5; i++) {
        props.client.prefetchQuery('fetch_tooling_parts', () => fetchPagedProducts({ ...state, paged: i + 1 }));
      }
    }, [state, props.client]
  )

  useEffect(() => {
    localStorage.setItem("tooling-catalog-state", JSON.stringify(state));
    prefetchQueries(state.paged);
    const event = new Event('storage-updated');
    window.dispatchEvent(event);
  }, [state, prefetchQueries]);


  const results = useQueries([
    {
      queryKey: ['fetch_tooling_parts', state],
      queryFn: () => fetchPagedProducts(state),
      keepPreviousData: true,
      onSuccess: () => {
        if (state.showLoader === true && dataRetrived === false) {
          setDataRetrived(true);
          dispatch({ type: "TOGGLE_LOADER" });
        }
      }
    },
    {
      queryKey: ['fetch_filter_options'],
      queryFn: () => fetchFilterOptions(state.filterOptions),
      onSuccess: (data) => {
        dispatch({ type: "SET_FILTER_OPTIONS", payload: data });
      }
    }
  ]);


  const FETCH_PARTS_RESPONSE = results[0];
  // const FETCH_FILTERING_RESPONSE = results[1];

  const columns = React.useMemo(
    () => [
      {
        Header: 'Root Part Number',
        accessor: "root_part_numbers",
        maxWidth: 400,
        // width: "25%",
        textAlign: "left"
      },
      {
        Header: 'Nomenclature',
        accessor: 'nomenclature',
        maxWidth: 400,
        // width: "30%",
        textAlign: "left"
      },
      {
        Header: 'Engine Oem',
        accessor: 'engine_oem',
        maxWidth: 400,
        // width: "20%",
        textAlign: "left"
      },
      {
        Header: 'Engine Applicability',
        accessor: 'engine_applicability',
        maxWidth: 400,
        // width: "15%",
        textAlign: "left"
      },
      {
        Header: 'QTY',
        accessor: 'qty',
        maxWidth: 400,
        // width: "10%",
        textAlign: "center"
      },
    ],
    []
  );

  const rows = React.useMemo(() => {
    if (typeof (FETCH_PARTS_RESPONSE.data) !== 'undefined' && FETCH_PARTS_RESPONSE.data != null) {
      return FETCH_PARTS_RESPONSE.data.products;
    }
  }, [FETCH_PARTS_RESPONSE.data]);

  if (FETCH_PARTS_RESPONSE.isError) return "An error has occurred: " + FETCH_PARTS_RESPONSE.error.message;

  if (state.showLoader) return <Loader message={state.loaderMessage} />


  return (
    <StateContext.Provider value={{ state: state, dispatch: dispatch }}>
      <div className="App">
        <div className="overflow-wrapper">
          <Filtering
            showFilters={showFilters}
            setShowFilters={setShowFilters}
          ></Filtering>
          {rows &&
            <Table
              showFilters={showFilters}
              setShowFilters={setShowFilters}
              columns={columns}
              data={rows}
              isLoading={FETCH_PARTS_RESPONSE.isLoading}
              isFetching={FETCH_PARTS_RESPONSE.isFetching}
            ></Table>
          }
        </div>
        {!FETCH_PARTS_RESPONSE.isLoading && FETCH_PARTS_RESPONSE.data.total_parts_count &&
          <Pagination
            totalNumberofProducts={FETCH_PARTS_RESPONSE.data.total_parts_count}
          ></Pagination>
        }
        <RequestCart
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        ></RequestCart>
      </div>
    </StateContext.Provider>
  );
}

export default App;